import { PharmaceuticalProperties } from '@/infrastructure/network/Monitaro/schema/models'

export interface IPharmaceuticalProps {
  id?: string
  companyId: string
  name: string | null
  order: number | null
  createdAt: string | null
  updatedAt: string | null
  properties: PharmaceuticalProperties | null
}

export default class PharmaceuticalEntity {
  private _props: IPharmaceuticalProps

  constructor(props?: IPharmaceuticalProps | null) {
    this._props = EmptyPharmaceuticalPropsFactory(props)
  }

  get props(): IPharmaceuticalProps {
    return this._props
  }

  get clone(): IPharmaceuticalProps {
    return structuredClone(this._props)
  }

  get id(): string | undefined {
    return this._props.id
  }

  get companyId(): string {
    return this._props.companyId
  }

  get name(): string | null {
    return this._props.name
  }

  get order(): number | null {
    return this._props.order
  }

  get createdAt(): string | null {
    return this._props.createdAt
  }

  get updatedAt(): string | null {
    return this._props.updatedAt
  }

  get properties(): PharmaceuticalProperties | null | undefined {
    return this._props.properties
  }
}

export const headers = [{ text: 'ID', value: 'id' }]

export const EmptyPharmaceuticalPropsFactory = (props?: Partial<IPharmaceuticalProps> | null): IPharmaceuticalProps => ({
  companyId: '',
  name: null,
  order: null,
  createdAt: null,
  updatedAt: null,
  properties: null,
  ...props
})
